import Controller from 'controllers/controller';
import CarouselController from 'controllers/carousel';

class MixologyController extends Controller {
    constructor(app) {
        super(app);
        
        this.root = document.querySelector('.page[data-template="mixology"]');
        
        this.elements = { };
        this.carousel = null;
        
        this.app.loaderController.on('mixology-loaded', () => {
            this.cacheElements();
            this.initCarousel();
        });
    }
    
    cacheElements() {
        this.elements.carousel = this.root.querySelector('.carousel');
    }
    
    initCarousel() {
        this.carousel = this.app.make(CarouselController, this.elements.carousel, {
            wrapAround: true
        });
    }
}

export default MixologyController;